import moment, { type Moment } from 'moment-timezone';

/**
 * Note: These functions use moment-timezone so do not refactor these to be
 * outside of the component.
 */

function getUserTimezone() {
  return window.currentUser?.zone ?? 'UTC';
}

/**
 * A JS date always gets converted to the local time zone. The customer's time
 * zone is not necessarily the same as the browser's time zone. This function
 * converts a moment to a JS date, but retains the time as if it were the
 * customer's time zone rather than the browser.
 */
export function momentToBrowserDateWithRetainedTime(time: Moment) {
  if (!time.isValid()) return null;

  return time
    .clone()
    .tz(getUserTimezone())
    .tz(new Intl.DateTimeFormat().resolvedOptions().timeZone, true)
    .toDate();
}

/**
 * The opposite of momentToBrowserDateWithRetainedTime, get back to a moment
 * with the time in the customer's time zone.
 */
export function dateToMomentWithRetainedTime(date: Date) {
  return moment(date).tz(getUserTimezone(), true);
}

export function inCurrentUserTimezone(time: Moment) {
  return time.clone().tz(getUserTimezone());
}
